<template>
  <div>
    <congrats-menu active="Bienvenidos"/>
    <v-layout row wrap>
      <v-flex sm1 pt-2 hidden-xs-only>
        <div class="fixed-celebration-buttons">
          <v-btn 
            v-for="date in dates"
            :key="date"
            :color="date == datePicker ? '#28385C' : 'white'"
            block
            class="btn-primary-security text-14-security"
            :class="date == datePicker ? 'white--text font-weight-bold' : ''"
            @click="changeDatePicker(date)"
            :disabled="todayMonth <= dates.indexOf(date) -1"
          >
              {{date}}
          </v-btn>
        </div>
      </v-flex>

      <v-flex hidden-sm-and-up>
        <v-select
          :items="dates"
          v-model="datePicker"
          label="Fecha"
          outline
          @change="changeDatePicker(datePicker)"
        ></v-select>
      </v-flex>

      <v-flex sm11 pt-2 :class="{'pt-2 pl-4': $vuetify.breakpoint.mdAndUp}">
        <welcome-infinite :date="datePicker" :monthNumber="dates.indexOf(datePicker)" :key="datePicker"></welcome-infinite>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import WelcomeInfinite from "./WelcomeInfinite"
import CongratsMenu from "../General/CongratsMenu"
import axios from "axios";
import { mapMutations, mapState } from "vuex";
import config from "@/config";
export default {
  components: {
    WelcomeInfinite,
    CongratsMenu
  },
  data() {
    return {
      page: 1,
      list: [],
      dates: ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"],
      datePicker: "enero",
      todayMonth: new Date().getMonth()
    };
  },
  methods: {
    changeDatePicker(date){
      this.datePicker = date
    }
  },
  mounted(){
    this.datePicker = this.dates[this.todayMonth]
  }
};
</script>